import React, { useEffect, useState } from "react";
import {
    Drawer,
    Box,
    Typography,
    IconButton,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper,
    TableHead
} from "@mui/material";
import close from "../../assets/icons/close.png";
import { getApprovalStatusDetails } from "../Services/OrgRepo";
import { showToast } from "../../Components/Toast";
import { getLoggedInUserID, LoggedInUserID } from "../../Utils/Constant";
export const PartsDrawer = ({
    open,
    onClose,
    selectedCORFQID,
    isStatusUpdated
}) => {
    // alert(open);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [allPartsApproved, setAllPartsApproved] = useState([]);
    const fetchRfqFeasibilityStakeHolderDetailsData = async (rfqID) => {
        setIsLoading(true);
        try {
            const response = await getApprovalStatusDetails(rfqID);
            setIsLoading(false);
            if (
                response?.status &&
                Array.isArray(response?.data) &&
                response?.data?.length > 0
            ) {
                response?.data?.forEach(
                    (eachPartRec: { deptHeadID: any; partIDs: any }) => {
                        if (eachPartRec?.deptHeadID === getLoggedInUserID()) {
                            setAllPartsApproved(eachPartRec?.partIDs);
                        }
                    }
                );
            } else {
                showToast({
                    message: response?.message || "No data found",
                    type: "error"
                });
            }
        } catch (error) {
            setIsLoading(false);
            showToast({
                message: error?.message || "An error occurred",
                type: "error"
            });
        }
    };
    // useEffect(() => {
    //   fetchRfqFeasibilityStakeHolderDetailsData(selectedCORFQID);
    // }, [selectedCORFQID, isStatusUpdated]);

    useEffect(() => {
        if (open) {
            fetchRfqFeasibilityStakeHolderDetailsData(selectedCORFQID);
        }
    }, [open]);
    return (
        <Drawer anchor="right" open={open} onClose={onClose}>
            <Box sx={{ p: 2, width: { xs: "100%", sm: 400 } }}>
                {/* Header Section */}
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                >
                    <Typography variant="h6" fontWeight="bold">
                        Approved Parts
                    </Typography>
                    <Box>
                        <IconButton onClick={onClose} sx={{ padding: "10px" }}>
                            <img src={close} width={"14px"} alt="Close" />
                        </IconButton>
                    </Box>
                </Box>
                <Divider sx={{ my: 2 }} />
                {/* Part Listing */}
                <>
                    <TableContainer
                        component={Paper}
                        sx={{
                            maxHeight: 400,
                            boxShadow: "none!important",
                            border: "1px solid #F2F2F2"
                        }}
                    >
                        <Table aria-label="Companies Table" stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        sx={{ backgroundColor: "#E3E8EF" }}
                                    >
                                        Part Number
                                    </TableCell>
                                    <TableCell
                                        sx={{ backgroundColor: "#E3E8EF" }}
                                    >
                                        Part Name
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {allPartsApproved?.length > 0 &&
                                    allPartsApproved?.map((item, index) => {
                                        return (
                                            <TableRow>
                                                <TableCell>
                                                    {item?.partNo}
                                                </TableCell>
                                                <TableCell>
                                                    {item?.partName}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </>
            </Box>
        </Drawer>
    );
};
